export const pricingPlans = [
  {
    name: "Local Entity Foundation",
    id: "foundation",
    price: "1,497",
    period: "month",
    description: "Ideal for small trades looking to fix their local footprint and start appearing in the Map Pack.",
    features: [
      "Google Business Profile Mastery",
      "Local Citation Sync (50+ Directories)",
      "Basic Schema Markup (JSON-LD)",
      "Monthly Truth Signal Report",
      "Keyword Research (Local Intent)",
      "Dedicated Account Manager"
    ],
    aeoStatus: "AEO Lite",
    cta: "Start Foundation",
    popular: false
  },
  {
    name: "AEO Growth Engine",
    id: "growth",
    price: "2,997",
    period: "month",
    description: "The sweet spot for growing HVAC, Plumbers, and Roofers who want to be the 'Direct Answer' on AI.",
    features: [
      "Everything in Foundation",
      "50-Word Rule Content Optimization",
      "FAQ & HowTo Schema Implementation",
      "Speakable Schema for Voice Search",
      "Semantic Triple Content Strategy",
      "Competitor Keyword Hijacking",
      "Quarterly Strategy Intensive"
    ],
    aeoStatus: "Full AEO Integration",
    cta: "Scale My Revenue",
    popular: true
  },
  {
    name: "Truth Protocol™ Dominator",
    id: "dominator",
    price: "5,497",
    period: "month",
    description: "Total market saturation. We build your entity authority until AI models have no choice but to cite you.",
    features: [
      "Everything in Growth Engine",
      "Full Truth Protocol™ Alignment",
      "Unlinked Brand Mention Campaign",
      "Revenue CRM & Lead Automation",
      "AI Voice Text-Back Integration",
      "High-Authority Digital PR",
      "Bi-Weekly Revenue Audits",
      "Exclusive City-Quadrant Lock"
    ],
    aeoStatus: "Maximum Entity Authority",
    cta: "Dominate My Market",
    popular: false
  }
];